export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    LOGOUT: 'USERS_LOGOUT',
    POSTNEW_PASSWORD: 'POST_NEW_PASSWORD',
    ASKNEW_PASSWORD: 'ASK_NEW_PASSWORD'
};
